import React from 'react';

import SEO from 'components/Seo';
import { graphql } from 'gatsby';
import { Layout } from '../components/layout';
import ServicesHero from '../sections/services/ServicesHero';
import ServicesHowWeWork from '../sections/services/ServicesHowWeWork';
import ServicesOtherServices from '../sections/services/ServicesOtherServices';
import IndustriesWorkedWith from '../sections/IndustriesWorkedWith';

const Services = ({ data }) => {
  const { ourServices, howWork, otherServices, auditInvite } =
    data.content.childMarkdownRemark.frontmatter;

  return (
    <Layout>
      <SEO title="Services" />
      <ServicesHero
        subTitle={ourServices.subTitle}
        title={ourServices.title}
        body={ourServices.body}
        services={ourServices.cards}
      />
      <ServicesHowWeWork title={howWork.title} subTitle={howWork.subTitle} cards={howWork.cards} />
      <ServicesOtherServices
        title={otherServices.title}
        subTitle={otherServices.subTitle}
        services={otherServices.cards}
        auditTitle={auditInvite.title}
        auditBody={auditInvite.body}
        auditButton={auditInvite.button}
      />
      <IndustriesWorkedWith />
    </Layout>
  );
};

export default Services;

export const PageQuery = graphql`
  query {
    content: file(name: { eq: "services" }) {
      childMarkdownRemark {
        frontmatter {
          ourServices {
            subTitle
            title
            body
            cards {
              title
              description
              imageContainer {
                image {
                  publicURL
                }
                altText
              }
            }
          }
          howWork {
            subTitle
            title
            cards {
              title
            }
          }
          otherServices {
            subTitle
            title
            cards {
              title
              description
              imageContainer {
                image {
                  publicURL
                }
                altText
              }
            }
          }
          auditInvite {
            title
            body
            button {
              text
              url
            }
          }
        }
      }
    }
  }
`;
